/**
 * Forwards a render-phase error to the console. There is no external error
 * reporter — render errors are logged here and surfaced by the route error
 * boundary.
 */
export function reportRenderError(
  error: Error,
  info: { componentStack: string },
) {
  console.error("[render error]", error, info);
}
